import { PAPI } from '@marketmuse/config/types';

export const SIGNUP_KEYS = {
  complete: 'complete',

  standard: `payment-standard`,

  onboardingData: 'onboardingData',

  confirmData: 'confirmData',
  confirmedData: 'confirmedData',
};

export const SIGNUP_STEPS = {
  // should see trial tutorial
  complete: [SIGNUP_KEYS.complete],

  // how to handle user fields in subscription flow
  confirm: [SIGNUP_KEYS.confirmData, SIGNUP_KEYS.confirmedData],

  // should see trial downmarket gate
  payment: [
    'standard',
    `payment:${PAPI.SubscriptionPlanType.RESEARCH}`,
    `payment:${PAPI.SubscriptionPlanType.OPTIMIZE}`,
    `payment:${PAPI.SubscriptionPlanType.STRATEGY}`,
  ],

  // should see onboarding data selector
  onboarding: [SIGNUP_KEYS.onboardingData],
};
